import React from "react";
import Foods from "../../data/Foods";
import { IFoodAmount, type IRecipe } from "../../shared/Recipes";
import FactsheetTotal from "../Factsheet/FactsheetTotal";
import { RecipeFullscreen } from "../Dialogs/FullscreenDlg";

function FoodRow(props:{food:IFoodAmount}) {
    const foodName = Foods.i.name(props.food.id)
    const amount = props.food.amount + " " + props.food.unit
    return <div className="row flex between gap-24">
        <label className="w700">{foodName}</label>
        <div className="nowrap">{amount}</div>
    </div>
}
export default function RecipeViewer() {
    const {item} = RecipeFullscreen.useFullscreen()
    const foods = item.foods.map(food => <FoodRow food={food} key={food.id}/>)
    return <div className="recipe">
        <p className="medium-text">{item.description}</p>
        <div className="medium-text"><label>Serves: </label>{item.servings}</div>
        <div className="foods">{foods}</div>
        <FactsheetTotal foods={item.foods}/>
    </div>
}